// :: START :: Product Gallery v1, v2, v3

$('.product-gallery-single').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  asNavFor: '.product-gallery-thumbnails'
});
$('.product-gallery-thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-gallery-single',
  infinite: false,
  arrows: true,
  dots: false,
  focusOnSelect: true,
  prevArrow: '<button class="slick-prev slick-arrow"><span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.99805L7.5 5.99805L4.5 8.99805" stroke="#190B41" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>',
  nextArrow: '<button class="slick-next slick-arrow"><span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.99805L7.5 5.99805L4.5 8.99805" stroke="#190B41" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      }
    }
  ]
});

// :: END :: Product Gallery v1, v2, v3

//Zoom icon auto tigger start
jQuery('.pgs-button').click(function(){
  jQuery('.slick-current.slick-active').find('.product__media-toggle').trigger('click');
});

/* CUSTOM CART DRAWER -- JS START */

function openMiniCart(cartContainer){
  cartContainer.addClass('cart-drawer-open');
  jQuery('body').addClass('cartcustom-drawer-open');
}
function closeMiniCart(){
  jQuery('.mini_cart').each(function(){
   jQuery(this).removeClass('cart-drawer-open');
  });
  jQuery('body').removeClass('cartcustom-drawer-open');
}
jQuery(document).on('click','.cart_close_btn',function(){
  closeMiniCart();
})
$('#cart-icon-bubble').on('click',function (e) {
    //e.preventDefault();
  if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
    const $cartContainer = $(this);
    openMiniCart($cartContainer);
  }
});

function drawerOpen(){
  if(jQuery('.cart-summary').hasClass('enbled-custom-drawer') || jQuery('body').hasClass('cart-progress_first')){
    jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if(cartData.length>0){
        subTotal = cart.original_total_price;
      }
      var tempCounter=0;
      let productHasSale = false;
      let productCompareAtPrice = 0;
      let productFinalPrice = 0;
      
      $.each(cartData, function(index, item) {
        let savingPercentage=0;
        let comparePrice = 0;
        var variantId = item.variant_id;
        var productId = item.product_id;
        var productTitle = item.title;
        var image = item.featured_image['url'];
        var priceMain = Shopify.formatMoney(item.price);
        var productHandle = item.handle;
        // Call the getProductData function with the product handle and the callback function
        var qunatity = item.quantity;
        var optionsdata = item.options_with_values;
        cartstr+='<div class="cart-summary__product" id="product_'+variantId+'">';
        cartstr+='<div class="cart-summary__product-image">';
        cartstr+='<img class="cart-item-media" alt="" src="'+image+'">';
        cartstr+='</div>';
        cartstr+='<div class="cart-summary__product__description">';
        cartstr+='<div class="cart-summary__product-title">';
        cartstr+='<h4 class="cart-product-title"><a href="/products/'+productHandle+'" title="">'+productTitle+'</a></h4>';
        $.ajax({
            dataType: 'json',
            async: false,
            cache: false,
            url: `/products/${item.handle}.js`,
            success(data) {
              let productData = data;
              // If item has more than one variant, need to make sure we are pulling data from the correct variant
              if (productData.variants) {
                const itemVariants = productData.variants;
                if (itemVariants.length > 1) {
                  for (let v = 0; v < itemVariants.length; v++) {
                    if (itemVariants[v].id === item.id) {
                      productData = itemVariants[v];
                    }
                  }
                }
              }
  
              // If compare at price exists then item is on sale
              if (productData.compare_at_price!="") {
                if (productData.compare_at_price > productData.price) {
                  productHasSale = true;
                  productCompareAtPrice = Shopify.formatMoney(productData.compare_at_price);
                  productFinalPrice = productData.price;
                  var vPrice = parseFloat(productData.compare_at_price / 100);
                  var price = parseFloat(productData.price / 100);
                  if (vPrice > price) {
                    comparePrice = parseFloat(productData.compare_at_price);
                    comparePrice = Shopify.formatMoney(comparePrice);
                    
                    var saving = ((vPrice - price) / vPrice) * 100;
                    savingPercentage = Math.round(saving);
                  }
                } else {
                  // Check required for non-sale items
                  productHasSale = false;
                }
              } else {
                // Check required for non-sale items
                productHasSale = false;
              }
            },
         });
         var compareString = '';
         if(comparePrice!=0){
          compareString+='<span class="c_price_compare">'+comparePrice+'</span>';
        }
        var savingString = '';
        if(savingPercentage!=0){
          savingString+='<span class="cart-product-pricesave">SAVE '+savingPercentage+'%</span>';
        }
        cartstr+=savingString;
        //cartstr+='<div class="cart_product_removeicon product-remove-custom" data-variantid="'+variantId+'" data-pcartid="'+productId+'">';
        //cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">';
        //cartstr+='<path d="M16.6667 5.0013H13.3333V4.16797C13.3333 3.50493 13.0699 2.86904 12.6011 2.4002C12.1323 1.93136 11.4964 1.66797 10.8333 1.66797H9.16667C8.50363 1.66797 7.86774 1.93136 7.3989 2.4002C6.93006 2.86904 6.66667 3.50493 6.66667 4.16797V5.0013H3.33333C3.11232 5.0013 2.90036 5.0891 2.74408 5.24538C2.5878 5.40166 2.5 5.61362 2.5 5.83464C2.5 6.05565 2.5878 6.26761 2.74408 6.42389C2.90036 6.58017 3.11232 6.66797 3.33333 6.66797H4.16667V15.8346C4.16667 16.4977 4.43006 17.1336 4.8989 17.6024C5.36774 18.0712 6.00363 18.3346 6.66667 18.3346H13.3333C13.9964 18.3346 14.6323 18.0712 15.1011 17.6024C15.5699 17.1336 15.8333 16.4977 15.8333 15.8346V6.66797H16.6667C16.8877 6.66797 17.0996 6.58017 17.2559 6.42389C17.4122 6.26761 17.5 6.05565 17.5 5.83464C17.5 5.61362 17.4122 5.40166 17.2559 5.24538C17.0996 5.0891 16.8877 5.0013 16.6667 5.0013ZM8.33333 4.16797C8.33333 3.94695 8.42113 3.73499 8.57741 3.57871C8.73369 3.42243 8.94565 3.33464 9.16667 3.33464H10.8333C11.0543 3.33464 11.2663 3.42243 11.4226 3.57871C11.5789 3.73499 11.6667 3.94695 11.6667 4.16797V5.0013H8.33333V4.16797ZM14.1667 15.8346C14.1667 16.0556 14.0789 16.2676 13.9226 16.4239C13.7663 16.5802 13.5543 16.668 13.3333 16.668H6.66667C6.44565 16.668 6.23369 16.5802 6.07741 16.4239C5.92113 16.2676 5.83333 16.0556 5.83333 15.8346V6.66797H14.1667V15.8346Z" fill="#13043D"/></path>';
        //cartstr+='</svg></div>';
        cartstr+='</div>';
        cartstr+='<div class="cart-summary__variantgroup"><div class="cart_product__variant">';
          if(optionsdata.length>0){
            for(var t=0;t<optionsdata.length;t++){
              if (optionsdata[t].value != 'Default Title' ){
              cartstr+='<div class="added-notice__variant">';
              cartstr+='<span class="cpv-label added-notice__variant-label">'+optionsdata[t].name.replace('Protein ','')+':</span>';
              cartstr+='<span class="cpv-value added-notice__variant-value">'+optionsdata[t].value+'</span>';
              cartstr+='</div>';
                }
            }
        }
        cartstr+='</div></div><div class="cart_product_variantquantity">';
        cartstr+='<div class="cart-summary__product__variants">';
        cartstr+='<div class="cart_product__pricebox">';
        cartstr+=compareString;
        cartstr+='<span class="c_price_sale">'+priceMain+'</span>';
        cartstr+='</div></div>';
        cartstr+='<div class="cart_product_quntitybox">';
        cartstr+='<div class="qty-container">';
        cartstr+='<button class="quantity-ctas qty-btn-minus btn-light" type="button" data-pcartid="'+productId+'">';
        cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
        cartstr+='<path d="M11.0807 7.58073H2.91406V6.41406H11.0807V7.58073Z" fill="#717171"/></path></svg>';
        cartstr+='</button><input type="text" name="quantity" data-variantid="'+variantId+'" id="pquantity_'+variantId+'" value="'+qunatity+'" class="input-qty qunatity-picker-custom">';
        cartstr+='<button class="quantity-ctas qty-btn-plus btn-light" type="button" data-pcartid="'+productId+'">';
        cartstr+='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
        cartstr+='<path d="M11.0807 7.58073H7.58073V11.0807H6.41406V7.58073H2.91406V6.41406H6.41406V2.91406H7.58073V6.41406H11.0807V7.58073Z" fill="#717171"/></path>';
        cartstr+='</svg></button></div></div>';
        cartstr+='</div></div></div></div>';
        cartCounter++;
      });
      var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
      var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
      var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
      var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
  
      if(cartData.length>0){
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
    
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }
        
    
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += Shopify.formatMoney(goalPendingAmount);
          tempStr += '</span>'
          tempStr += goalAfterText;
        }
        else{
          tempStr += goalReachText;
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }
      // console.log("goalAmount", goalAmount);
      // console.log("cartTotalFull", cartTotalFull);
  
      // console.log("tempStr", tempStr);
      if(jQuery('.cart-summary').length!=0){
        //jQuery('.cart-summary__total-quantity-row').find('span').eq(1).text(qunatity);
        //jQuery('.cart-summary__total-price-row').find('.theme-money').text(formatMoney(subTotal, theme.moneyFormatWithCodeForProductsPreference));
        jQuery('.cart-summary__total-price-row').find('.theme-money').text(Shopify.formatMoney(subTotal));
        jQuery('.cart-summary__product-list').html('');
        jQuery('.header-cart__count').text(totalCart);
        jQuery('.cart-summary__product-list').html(cartstr);
      }
      jQuery('.cart_product__count').html('('+cart.item_count+')');
      jQuery('.header-cart__count').html(cart.item_count);
  
      if(cart.item_count == 0){
        jQuery('.cart__empty_data').show();
        jQuery('.cart_look_productbox').hide();
        jQuery('.cart-summary__footer').hide();
        jQuery('.cc-cart-progress').hide();
        jQuery('.cart-summary__product-list').html('');
        jQuery('.cart-count-bubble span').eq(0).text(0);
      }
      else{
        jQuery('.cart__empty_data').hide();
        jQuery('.cart_look_productbox').show();
        jQuery('.cart-summary__footer').show();
        jQuery('.cc-cart-progress').show();
        if(jQuery('.cart-count-bubble').length==0){
          jQuery('#cart-icon-bubble span').after('<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span></div>');
        }else{
          jQuery('.cart-count-bubble span').eq(0).text(cart.item_count);
        }
      }
      if(cartCounter==totalCart){
        setTimeout(function(){
          jQuery('body').addClass('cartcustom-drawer-open');
        },620);
      }
    });
  }
}


function refreshCartProgress(){
  if(jQuery('body').hasClass('cart-progress_second') || jQuery('body').hasClass('cart-progress_first')){
    jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if(cartData.length>0){
        subTotal = cart.original_total_price;
      }
      var tempCounter=0;
      let productHasSale = false;
      let productCompareAtPrice = 0;
      let productFinalPrice = 0;
      
      var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
      var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
      var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
      var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
  
      if(cartData.length>0){
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
          jQuery('.cart-progress').removeClass("cart_progress-filled");
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
          jQuery('.cart-progress').addClass("cart_progress-filled");
        }
        
    
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += Shopify.formatMoney(goalPendingAmount);
          tempStr += '</span>';
          tempStr += goalAfterText;
        }
        else{
          tempStr += '<span class="cart_goal_oldm">';
          tempStr += goalReachText;
          tempStr += '</span>';
          tempStr += '<span class="cart_goal_newm" style="display: none;">🎉 Congrats! You unlocked <strong>FREE shipping</strong></span>';
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none"><path d="M15.4988 6.00232H13.2488V3.00232H1.24878V12.7523H2.74878C2.74878 13.9973 3.75378 15.0023 4.99878 15.0023C6.24378 15.0023 7.24878 13.9973 7.24878 12.7523H11.7488C11.7488 13.9973 12.7538 15.0023 13.9988 15.0023C15.2438 15.0023 16.2488 13.9973 16.2488 12.7523H17.7488V9.00232L15.4988 6.00232ZM4.99878 13.5023C4.58628 13.5023 4.24878 13.1648 4.24878 12.7523C4.24878 12.3398 4.58628 12.0023 4.99878 12.0023C5.41128 12.0023 5.74878 12.3398 5.74878 12.7523C5.74878 13.1648 5.41128 13.5023 4.99878 13.5023ZM15.1238 7.12732L16.5938 9.00232H13.2488V7.12732H15.1238ZM13.9988 13.5023C13.5863 13.5023 13.2488 13.1648 13.2488 12.7523C13.2488 12.3398 13.5863 12.0023 13.9988 12.0023C14.4113 12.0023 14.7488 12.3398 14.7488 12.7523C14.7488 13.1648 14.4113 13.5023 13.9988 13.5023Z" fill="black"/></path></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }

      if(cart.item_count == 0){
        jQuery('.cc-cart-progress').hide();
      }
      else{
        jQuery('.cc-cart-progress').show();
      }
      
    });
  }
}

setInterval(function() {
refreshCartProgress();
},1000);

function updateCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      $('.qty-container').removeClass('is-loading');
       drawerOpen();
    },
    error: function(response) {
      $('.qty-container').removeClass('is-loading');
        //alert(response);
    }
  });  
}

/***************** BUNDLE PACK OFFER -- START *******************/

jQuery(document).ready(function(){
  var fullUrl = window.location.href;
  var pathSegments = window.location.pathname.split('/').filter(Boolean);
  var lastSegment = pathSegments[pathSegments.length - 1];
  var interIds = setInterval(function(){
    const urlParams = new URLSearchParams(window.location.search);
    const planids = urlParams.get('selling_plan');
    if(lastSegment == 'lean-plant-protein' && planids!="" && planids!=undefined){
      if(jQuery('.protein_frequency').find('.pf_header_subscription').find('#subscribe').length>0){
        jQuery('.protein_frequency').find('.pf_header_subscription').find('.pf_header_subscription').eq(0).trigger('click');
        jQuery('.protein_frequency').find('.pf_header_subscription').find('.pf_subscription_label[for="subscribe"]').trigger('click');
        setTimeout(function(){
          var tooltipObject = jQuery('.shopify-block.recharge-subscription-widget').find('div.rc-tooltip');
          var tooltipName = tooltipObject.find('.how-it-works strong').text();
          var tooltipDescription = tooltipObject.find('.how-it-works').html().split('<br>')[1];
          tooltipDescription = tooltipDescription.trim();
          var tooltipAnchor = tooltipObject.find('.rc-tooltip__footer a').attr('href');
          var tooltipAnchorText = tooltipObject.find('.rc-tooltip__footer a').find('span').text();
          //console.log("tooltipAnchor",tooltipAnchorText);
          jQuery('.protein_frequency').find('.pf_subscription_popup .tooltip_title').text(tooltipName);
          jQuery('.protein_frequency').find('.pf_subscription_popup .description').text(tooltipDescription);
          jQuery('.protein_frequency').find('.pf_subscription_popup .powered-button').attr('href',tooltipAnchor);
          jQuery('.protein_frequency').find('.pf_subscription_popup .powered-button').text(tooltipAnchorText);
        },1000);
      }
      clearInterval(interIds);
    }
  },1000);
});

jQuery(document).on('click','[name="add"]',function(e){
  //console.log("add to cart");
  //e.preventDefault();
  var variantId = jQuery(this).parent().parent('form').find('[name="id"]').val();
  var productId = jQuery(this).parent().parent('form').find('[name="id"]').attr('data-productid');
  var qunatity = parseInt(jQuery('.product__info-container').find('[name="quantity"]').val());
  if($('.product--details').hasClass('product_bundle_box')){
    var itemArr = []
    if($('.bundle_product_grid').hasClass('version_1')){
      itemArr.push({
        id: 43008263487727,
        quantity: 1
      });
    }
    else if($('.bundle_product_grid').hasClass('version_2')){
  
    }
    else if($('.bundle_product_grid').hasClass('version_3')){
  
    }
    itemArr.push({
        id: 43008263487727,
        quantity: 1
      });
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    console.log("itemArr==>", itemArr);
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
         drawerOpen();
        } else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  else if($('.product--details').hasClass('protein_offer_new')){
    addOfferProducts(qunatity,variantId,productId);
  }else{
    if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
      addItemCart(1,variantId);
    }else{
      addOfferProducts(qunatity,variantId,productId);
    }
  }
});
function addOfferProducts(qty, variantId, productId, properties = {}) {
  var itemArr = [];
  var kitActive = parseInt(jQuery('.protein_offer .protein_kit_options')
    .find('.protein_kit_btn.active')
    .find('[name="kit"]:checked')
    .val());
  
  if (kitActive === 1 && variantId && !isNaN(variantId) && qty > 0) {
    var sellingId = parseInt(jQuery('.protein_offer .protein_kit_options').find('.protein_kit_btn.active').attr('data-selling-id'));
    var getSubscription = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
    if(getSubscription == 'subscribe' && sellingId!=undefined && sellingId!=""){
      itemArr.push({
        id: parseInt(variantId),
        quantity: qty,
        properties: properties,
        selling_plan:sellingId
      });
    }else{
      itemArr.push({
        id: parseInt(variantId),
        quantity: qty,
        properties: properties
      });
    }
  }

  // Add your gift products (if needed)
  packwiseFreeGift(itemArr, variantId, productId);
  if(jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').length>0){
    jQuery('.product_buybutton_block').find('.product-form__submit').addClass('loading');
    jQuery('.product_buybutton_block').find('.product-form__submit').find('.loading-overlay__spinner').removeClass('hidden');
  }
  $.getJSON('/cart.js', function(cart) {
    let freeGiftItems = [];

    cart.items.forEach(function(item) {
      if (item.properties && item.properties.__freegift && !freeGiftItems.includes(item.variant_id)) {
        freeGiftItems.push(item.variant_id);
      }
    });
    var filteredItems = itemArr.filter(item =>
      item.id && !isNaN(item.id) && item.quantity > 0
    );

    if (filteredItems.length > 0) {
      var formData = new FormData();

      filteredItems.forEach((item, index) => {
        var variantIDs = parseInt(item.id);
        if(jQuery.inArray(variantIDs, freeGiftItems) == -1) {
          formData.append(`items[${index}][id]`, variantIDs);
          formData.append(`items[${index}][quantity]`, item.quantity);
          if (item.selling_plan) {
            formData.append(`items[${index}][selling_plan]`, parseInt(item.selling_plan));
          }
          if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
              formData.append(`items[${index}][properties][${key}]`, item.properties[key]);
            });
          }
        }
      });
      //console.log("Final item array:", filteredItems);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function (cart) {
          //if (kitActive === 3 || kitActive==2) {
            window.location.href = '/cart';
          //}
        },
        error: function (response) {
          console.error("Error response:", response);
          //alert('Some items could not be added to the cart!');
        }
      });
    } else {
      console.warn("No valid items to add to cart.");
    }
  });
}

function packwiseFreeGift(itemArr,variantId,productId){
  if(jQuery('.protein_frequency').find('[name="recharge_custom"]').length>0){
    var getSubscription = jQuery('.protein_frequency').find('[name="recharge_custom"]:checked').val();
    var kitActive = jQuery('.protein_offer .protein_kit_options').find('.protein_kit_btn.active').find('[name="kit"]:checked').val();
    var bundlePack = 'one';
    if(kitActive==2){
      bundlePack = 'two';
    }else if(kitActive==3){
      bundlePack='three';
    }
    if(getSubscription == 'subscribe'){
      kitActive = parseInt(kitActive);
      if(kitActive){
        var bootyFree = jQuery('.protein_frequency_box').find('.bootyprogram_gift_free').attr('data-vid');
        itemArr.push({
          id: bootyFree,
          quantity: 1,
          properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
        });
        if(kitActive==2 || kitActive==3){
          var shippingFree = jQuery('.protein_frequency_box').find('.shipping_gift_free').attr('data-vid');
          /*itemArr.push({
            id: shippingFree,
            quantity: 1,
            properties:{'__product_id':productId,'__freegift':1}
          });*/
          
          var shakerFree = jQuery('.protein_frequency_box').find('.shaker_gift_free').attr('data-vid');
          //console.log("shakeeeee",shakerFree);
          itemArr.push({
            id: shakerFree,
            quantity: 1,
            properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
          });
          if(kitActive==3){
            strkit = 'bundle';
            var magnesiumFree = jQuery('.protein_frequency_box').find('.magnesium_gift_free').attr('data-vid');
            itemArr.push({
              id: magnesiumFree,
              quantity: 1,
              properties:{'__product_id':productId,'__freegift':1,'__bundle_type':bundlePack}
            });
          }
          //console.log("length",jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').length);
        }
      }
    }
    var strkit='';
    if(kitActive==2){
      strkit='double';
    }else if(kitActive==3){
      strkit = 'bundle';
    }
    if(strkit!=""){
      if(jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').length > 0) {
        jQuery('.protein_offer .protein_flavors.'+strkit+'_flavors .select__select').each(function() {
          var selectedVal = jQuery(this).find('option:selected').val();
          var sellingPlanId = jQuery(this).find('option:selected').attr('data-selling-plan-id');
          if (selectedVal) {
            if(getSubscription == 'subscribe'){
              if(sellingPlanId==undefined){
                sellingPlanId=0;
              }
              itemArr.push({
                id: selectedVal,
                quantity: 1,
                selling_plan:sellingPlanId,
                properties:{'__bundle_type':bundlePack}
              });
            }else{
              itemArr.push({
                id: selectedVal,
                quantity: 1,
                properties:{'__bundle_type':bundlePack}
              });
            }
          }
        });
      }
    }
    console.log("itemArr",itemArr);
    return itemArr;
  }
}


$(document).ready(function () {
  $(".single_option").addClass("active");
  $(".protein_kit_btn").on("click", function (e) {
    $(".protein_kit_btn").removeClass("active");
    $(this).addClass("active");
    $(".protein_kit_btn").find('[type="radio"]').removeAttr("checked");
    $(this).find('[name="kit"]').attr('checked',true);
    var typeskit = jQuery(this).find('[name="kit"]').val();
    toggleContent();
    setTimeout(function(){
      showHideFreeProduct(typeskit);
    },200);
    //console.log("buuuuuuu");
    //if(jQuery(this).find('[name="kit"]').val()==3){
      jQuery('.product_buybutton_block').find('.product-form__submit').attr('type','button');
    /*}else{
      jQuery('.product_buybutton_block').find('.product-form__submit').attr('type','submit');
    }*/
    e.preventDefault();
  });

  function showHideFreeProduct(typeskit){
    //console.log("typeskit",typeskit);
    typeskit = parseInt(typeskit);
    if(typeskit==1){
      jQuery('.protein_frequency').find('.gift_product_box.shipping_gift_free').hide();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free').hide();
      
    }else if(typeskit==2  || typeskit==3){
      jQuery('.protein_frequency').find('.gift_product_box.shipping_gift_free').show();
      jQuery('.protein_frequency').find('.gift_product_box.shaker_gift_free').show();
    }
  }
  
  function toggleContent() {
    console.log("chhhhh",$("#double_portein").is(":checked"));
    $(".single_flavors, .double_flavors, .bundle_flavors").hide(); // Hide all first
    if(jQuery('.product--details').find('.protein_offer').length>0){
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').attr('type','button');
    }
    if ($("#single_portein").is(":checked")) {
      var offprice = $("#single_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();
      var sprice = $("#single_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      $(".single_flavors").show();

      $('.pf_onetime_details h6').html('Switch to a subscription and <span>save 10%</span>.');

      $('.pf_subtitle_vone').html('Subscribe & Save 10%');
      $('.pf_subtitle_vtwo').html('Subscribe & <b>Save 10%</b>');

      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);
      
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_third');
    } 
    else if ($("#double_portein").is(":checked")) {
      var cprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_compare_price').text();
      var sprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      var offprice = $("#double_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();

      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);

      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(sprice);
      
      $('.pf_subtitle_vone').html('Subscribe & Save 20%');
      $('.pf_subtitle_vtwo').html('Subscribe & <b>Save 20%</b>');
      $('.pf_onetime_details h6').html('Switch to a subscription and <span>save 20%</span>.');
      
      $(".double_flavors").show();
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_third');
    } 
    else if ($("#bundle_portein").is(":checked")) {
      var cprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_compare_price').text();
      var sprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.pk_sale_price').text();
      var offprice = $("#bundle_portein").parent().parent().find('.pk_inner_content').find('.pk_option_pricebox').find('.ten_off_price').text();

      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_compareprice').text(sprice);
      $('.pf_header_subscription').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(offprice);

      $('.pf_header_onetime').find('.pf_subscription_label').find('.pf_subscription_pricebox').find('.pf_subscription_saleprice').text(sprice);

      $('.pf_subtitle_vone').html('Subscribe & Save 28%');
      $('.pf_subtitle_vtwo').html('Subscribe & <b>Save 28%</b>');
      $('.pf_onetime_details h6').html('Switch to a subscription and <span>save 28%</span>.');
      
      $(".bundle_flavors").show();
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_first');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').removeClass('protein_offer_second');
      $('.product_buybutton_block').find('.product-form').find('.form').find('[name="add"]').addClass('protein_offer_third');
    }
  }

  toggleContent();
  $("input[name='kit']").on("change", toggleContent);

  function toggleContentSubscribe() {
    if ($("#subscribe").is(":checked")) {
      $(".pf_subscribe_content").show();
      $(".pf_onetime_content").hide();
      $(".rc-widget").find('.rc-template__radio').find('.subscription-radio').find('[name="purchaseOption"]').trigger('click');
    } 
    else {
      $(".pf_subscribe_content").hide();
      $(".pf_onetime_content").show();
      $(".rc-widget").find('.rc-template__radio').find('.onetime-radio').find('[name="purchaseOption"]').trigger('click');
    }
  }
  toggleContentSubscribe();
  $("input[name='recharge_custom']").on("change", toggleContentSubscribe);

  $(".product-form__input_v1 label").on("click", function () {
    var vid = $(this).attr('data-vid');
    $(".product-form__input_v1 label").removeClass('active');
    $(this).addClass('active');
    $('.product_buybutton_block').find('.product-form').find('.form').find('[name="id"]').val(vid);
  });
});

/***************** BUNDLE PACK OFFER -- END *******************/

/*jQuery(document).on('click','[name="add"]',function(e){
  console.log("add to cart");
  //e.preventDefault();
  var variantId = jQuery(this).parent().parent('form').find('[name="id"]').val();
  if($('.product--details').hasClass('product_bundle_box')){
    var itemArr = []
    if($('.bundle_product_grid').hasClass('version_1')){
      itemArr.push({
        id: 43008263487727,
        quantity: 1
      });
    }
    else if($('.bundle_product_grid').hasClass('version_2')){
  
    }
    else if($('.bundle_product_grid').hasClass('version_3')){
  
    }
    itemArr.push({
        id: 43008263487727,
        quantity: 1
      });
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    console.log("itemArr==>", itemArr);
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
        if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
         drawerOpen();
        } else{
          window.location.href = '/cart';
        }
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  else{
    if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
      addItemCart(1,variantId);
    }
  }
});*/


jQuery(document).on('click','.product_add_btn',function(e){
  if(jQuery('.combine_supplements_v1').length!=0){
    var variantId='';
    variantId = jQuery(this).attr('data-vid');
    addUpsellItemCart(1,variantId);
  }
});

jQuery(document).on('change','.product_add_sel',function(e){
  if(jQuery('.combine_supplements_v1').length!=0){
    var variantId='';
    variantId = jQuery(this).val();
    addUpsellItemCart(1,variantId);
    jQuery(this).prop('selectedIndex',0);
    // prevent click action
    e.preventDefault();
    // your code here
    return false;
  }
});

function addUpsellItemCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      console.log("iinnn->", cart)
      //window.location.reload;
      jQuery.getJSON('/cart.js', function(cart1) {
        console.log("parsedState--->", cart1)
        var cartItemCount = cart1.item_count;
        var cartCountStr = '';
        if(cartItemCount > 0){
          jQuery('.cart-count-bubble span').eq(0).text(cartItemCount);
          if(cartItemCount == 1){
            cartCountStr = cartItemCount+' item';
          }
          else{
            cartCountStr = cartItemCount+' items';
          }
          jQuery('.cart-count-bubble span').eq(1).text(cartItemCount);

          var cartTotalAmount = cart1.total_price;
          var cartDiscount = cart1.cart_level_discount_applications;
          if(cartDiscount.length > 0){
            console.log("title--->", cartDiscount[0].title)
            var svgStr = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg>';
            var discountStr = svgStr + cartDiscount[0].title + ' (-'+Shopify.formatMoney(cartDiscount[0].total_allocated_amount)+')';            
            jQuery('.discounts__discount--end').html(discountStr);
          }

          var currencySign = jQuery('#in-context-paypal-metadata').attr('data-currency');
          jQuery('.totals__subtotal-value').text(Shopify.formatMoney(cartTotalAmount)+ ' '+currencySign);

          var cartItemStr = '';
          var counter = 1;
          cart1.items.forEach(function(item) {
            console.log("Item Details:", item);

            // Example: Access item properties
            var itemTitle = item.title; // Title of the product
            var itemQuantity = item.quantity; // Quantity of the product
            var itemPrice = item.price; // Convert price from cents to dollars/euros
            var itemImage = item.image; // Product image URL
            var itemVariantId = item.variant_id; // Variant ID
            var itemUrl = item.url; // Product URL
            var itemVendor = item.vendor; // Product Vendor
            var itemvariant_title = item.variant_title;
            var itemPid = item.product_id;

            jQuery('[data-pid="'+itemPid+'"]').hide();
            // Example: Log details or use in your UI
            console.log(`Title: ${itemTitle}`);
            console.log(`Quantity: ${itemQuantity}`);
            console.log(`Price: ${itemPrice}`);
            console.log(`Image: ${itemImage}`);
            console.log(`Variant ID: ${itemVariantId}`);

            cartItemStr += '<tr class="cart-item" id="CartItem-'+counter+'">';
            cartItemStr += '<td class="cart-item__media">';
            cartItemStr += '<a href="'+itemUrl+'" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>';
            cartItemStr += '<img class="cart-item__image" src="'+itemImage+'" alt="'+itemTitle+'" loading="lazy" width="150" height="150">';
            cartItemStr += '</td>';
            cartItemStr += '<td class="cart-item__details">';
            cartItemStr += '<p class="caption-with-letter-spacing light">'+itemVendor+'</p><a href="'+itemUrl+'" class="cart-item__name break">'+itemTitle+'</a><dl><div class="product-option">';
            cartItemStr += '<dt>Flavor:</dt>';
            cartItemStr += '<dd>'+itemvariant_title+'</dd>';
            cartItemStr += '</div></dl>';
            cartItemStr += '<p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>';
            cartItemStr += '<div class="cart-item__error" id="Line-item-error-'+counter+'" role="alert">';
            cartItemStr += '<small class="cart-item__error-text"></small>';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">';
            cartItemStr += '<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>';
            cartItemStr += '<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>';
            cartItemStr += '<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>';
            cartItemStr += '<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</td>';
            
            cartItemStr += '<td class="cart-item__totals right medium-hide large-up-hide">';
            cartItemStr += '<div class="loading-overlay hidden">';
            cartItemStr += '<div class="loading-overlay__spinner">';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
            cartItemStr += '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</div>';
            cartItemStr += '<div class="cart-item__price-wrapper"><span class="price price--end">';
            cartItemStr += Shopify.formatMoney(itemPrice);
            cartItemStr += '</span></div>';
            cartItemStr += '</td>';
            
            cartItemStr += '<td class="cart-item__quantity">';
            cartItemStr += '<label class="visually-hidden" for="Quantity-'+counter+'">';
            cartItemStr += 'Quantity';
            cartItemStr += '</label>';
            cartItemStr += '<quantity-input class="quantity">';
            cartItemStr += '<button data-pid="'+itemPid+'" class="quantity__button no-js-hidden" name="minus" type="button">';
            cartItemStr += '<span class="visually-hidden">Decrease quantity for '+itemTitle+'</span>';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">';
            cartItemStr += '<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">';
            cartItemStr += '</svg>';
            cartItemStr += '</button>';
            cartItemStr += '<input class="quantity__input" type="number" name="updates[]" value="'+item.quantity+'" min="0" aria-label="Quantity for '+itemTitle+'" id="Quantity-'+counter+'" data-index="'+counter+'" >';
            cartItemStr += '<button class="quantity__button no-js-hidden" name="plus" type="button" >';
            cartItemStr += '<span class="visually-hidden">Increase quantity for '+itemTitle+'</span>';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">';
            cartItemStr += '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">';
            cartItemStr += '</svg>';
            cartItemStr += '</button>';
            cartItemStr += '</quantity-input>';
            
            cartItemStr += '<cart-remove-button id="Remove-'+counter+'" data-index="'+counter+'" class="remove_product_cart" data-pid="'+itemPid+'">';
            cartItemStr += '<a href="/cart/change?id='+item.key+'&quantity=0" class="button button--tertiary" aria-label="Remove '+itemTitle+' - '+itemvariant_title+'" >';
            cartItemStr += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">';
            cartItemStr += '<path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>';
            cartItemStr += '<path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>';
            cartItemStr += '</svg>';
            cartItemStr += '</a>';
            cartItemStr += '</cart-remove-button>';
            cartItemStr += '</td>';
            
            cartItemStr += '<td class="cart-item__totals right small-hide">';
            cartItemStr += '<div class="loading-overlay hidden">';
            cartItemStr += '<div class="loading-overlay__spinner">';
            cartItemStr += '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
            cartItemStr += '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
            cartItemStr += '</svg>';
            cartItemStr += '</div>';
            cartItemStr += '</div>';
            cartItemStr += '<div class="cart-item__price-wrapper"><span class="price price--end">';
            cartItemStr += Shopify.formatMoney(itemPrice);
            cartItemStr += '</span></div>';
            cartItemStr += '</td>';
            cartItemStr += '</tr>';
            counter++;
          });
          jQuery('#cart__item__list').html(cartItemStr);

          setTimeout(function() {
            var totalLength = 0;
            var totalLoopItem = 0;
            jQuery('.combine_supplements_v1').find('.combine_main_card').find('.combine_card').each(function() {
              totalLoopItem++;
              if($(this).css('display') == 'none'){
                totalLength++;
              }
            });
            
            if(totalLoopItem == totalLength){
              jQuery('.combine_supplements_v1').addClass('hide_sec');
            }

            var totalLength1 = 0;
            var totalLoopItem1 = 0;
            jQuery('.combine_supplements_v1_2').find('.combine_main_card').find('.combine_card').each(function() {
              totalLoopItem1++;
              if($(this).css('display') == 'none'){
                totalLength1++;
              }
            });
            
            if(totalLoopItem1 == totalLength1){
              jQuery('.combine_supplements_v1_2').addClass('hide_sec');
            }
          }, 500);
          
        }
      });
      return false;
    },
    error: function(response) {
        alert('Something went wrong!!');
    }
  });
}

setInterval(function() {
  var totalLength = 0;
  var totalLoopItem = 0;
  var totalLength1 = 0;
  var totalLoopItem1 = 0;
  jQuery('.combine_supplements_v1').find('.combine_main_card').find('.combine_card').each(function() {
    totalLoopItem++;
    if($(this).css('display') == 'none'){
      totalLength++;
    }
  });

  jQuery('.combine_supplements_v1_2').find('.combine_main_card').find('.combine_card').each(function() {
    totalLoopItem1++;
    if($(this).css('display') == 'none'){
      totalLength1++;
    }
  });
  
  if(totalLoopItem == totalLength){
    jQuery('.combine_supplements_v1').addClass('hide_sec');
  }
  else{
    jQuery('.combine_supplements_v1').removeClass('hide_sec');
  }

  if(totalLoopItem1 == totalLength1){
    jQuery('.combine_supplements_v1_2').addClass('hide_sec');
  }
  else{
    jQuery('.combine_supplements_v1_2').removeClass('hide_sec');
  }
}, 100);

jQuery(document).on("click",".remove_product_cart",function(){
  if(jQuery('.combine_supplements_v1').length!=0){
    var productId = jQuery(this).attr('data-pid');
    setTimeout(function(){
      jQuery('.combine_main_card').find('.combine_card[data-pid="'+productId+'"]').show();
    },1000);
  }
});

jQuery(document).on("click","#main-cart-items [name='minus']",function(){
  if(jQuery('.combine_supplements_v1').length!=0){
    var productId = jQuery(this).attr('data-pid');
    var quantity = jQuery(this).siblings('.quantity__input').val();
    if(eval(quantity)==0){
      setTimeout(function(){
        jQuery('.combine_main_card').find('.combine_card[data-pid="'+productId+'"]').show();
      },1000);
    }
  }
});

jQuery(document).ready(function(){
  setTimeout(function(){
    var upsellCount = jQuery('#upsell_count').val();
    if(eval(upsellCount) == eval(jQuery('.combine_card').length)){
      jQuery('.cart_upsell_box').addClass("hide_upsell");
    }
  },1000);
});

function addItemCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      if(jQuery('.cart-summary').hasClass('enbled-custom-drawer')){
       drawerOpen();
      } else{
        window.location.href = '/cart';
      }
    },
    error: function(response) {
        alert('Something went wrong!!');
    }
  });
}
jQuery(document).on('change','.qunatity-picker-custom',function(){
  var variantIdExist = jQuery(this).attr('data-variantid');
  var Quantity = jQuery(this).val();
  updateCart(Quantity,variantIdExist);
});

jQuery(document).on('click','.product-remove-custom',function(){
  var variantIdExist = jQuery(this).attr('data-variantid');
  updateCart(0,variantIdExist);
});

jQuery(document).on('click','.qty-btn-plus',function(){
  $(this).parent().addClass('is-loading');
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  $n.val(Number($n.val())+1 );
  var variantIdExist = $(this).parent('div').find('.qunatity-picker-custom').attr('data-variantid');
  var Quantity = $(this).parent('div').find('.qunatity-picker-custom').val();
  updateCart(Quantity,variantIdExist);
});

jQuery(document).on('click','.qty-btn-minus',function(){
  $(this).parent().addClass('is-loading');
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  var amount = Number($n.val());
  if (amount >= 1) {
    $n.val(amount-1);
  }
  var variantIdExist = $(this).parent('div').find('.qunatity-picker-custom').attr('data-variantid');
  var Quantity = $(this).parent('div').find('.qunatity-picker-custom').val();

  if(Quantity == 0){
    setTimeout(function(){
      var productId = $(this).attr('data-pcartid');
      jQuery('[product--id="'+productId+'"]').parent('div').show(); 
      jQuery('[product--id="'+productId+'"]').find('.btn__text').show();
    },1000);
  }
  
  updateCart(Quantity,variantIdExist);
});

jQuery('.product-form__buttons').click(function(){
   drawerOpen();
});
//custom drawer class add to drawer start and default functionality disabled start 
// jQuery(document).ready(function(){
//   jQuery('.cart-summary').addClass('enbled-custom-drawer');
//   jQuery('#cart-icon-bubble').attr('href','javascript:void(0);');
//   jQuery('.cart-notification').parent().removeClass('cart-notification-wrapper');
// });
/* CUSTOM CART DRAWER -- JS END */

jQuery(document).on('click','.cusom-add-btn',function(){
   var variantId = $(this).attr('data-vid');
   addItemCart(1,variantId);
});


// MENU DRAWER 

jQuery('.header__icon--menu').click(function(){
  jQuery('body').toggleClass('drawer_model__open');
  headerBaseSetHigthMenu();
})
jQuery(window).scroll(function(){
  headerBaseSetHigthMenu();
});
function headerBaseSetHigthMenu(){
  var announceHeight1=0;
  if(jQuery('#shopify-section-header').hasClass('shopify-section-header-sticky')){
    
  }else{
    announceHeight1 = document.querySelector('#shopify-section-announcement-bar');
    announceHeight1=announceHeight.clientHeight;
  }
  //console.log('announceHeight1',announceHeight1);
  var windowHeight = $(window).height();
  //console.log('window-Height',windowHeight);
  document.documentElement.style.setProperty('--vvh', windowHeight+'px');
  windowHeight = (windowHeight-announceHeight1);
  //console.log('windowHeight',windowHeight);
  document.documentElement.style.setProperty('--vh', windowHeight+'px');
}


// jQuery(document).ready(function() {
//     var $searchBar = jQuery('#Search-In-Modal-1');
//     jQuery('body').removeClass('search-active');
//     // When the search bar gains focus
//     $searchBar.on('focus', function() {
//         // Add a class or perform some action
//         jQuery('body').removeClass('search-active');
//     });

//     // When the search bar loses focus (after pressing "Done" on the keyboard)
//     $searchBar.on('blur', function() {
//         jQuery('body').addClass('search-active');
//     });
//     $searchBar.on('focusOut', function() {
//         jQuery('body').addClass('search-active');
//     });
// });

jQuery('.modal__close-button').click(function(){
  jQuery('body').removeClass("drawer_model__open");
  jQuery('body').removeClass("overflow-hidden-tablet");
})
jQuery('.menu-drawer__menu-item').click(function(){
  jQuery('.menu-drawer__inner-container').addClass('submenu__drawer_open');
})
jQuery('.menu-drawer__close-button').click(function(){
  jQuery('.menu-drawer__inner-container').removeClass('submenu__drawer_open');
})

const headerHeight = document.querySelector('#shopify-section-header');
document.documentElement.style.setProperty('--header-height', `${headerHeight.clientHeight}px`);

const announceHeight = document.querySelector('#shopify-section-announcement-bar');
document.documentElement.style.setProperty('--announce-height', `${announceHeight.clientHeight}px`);

//redirect menu click set code start
// jQuery(document).on('click','.menu-drawer__menu-item',function(e) {
//   var menuText = jQuery(this).text();
//   menuText = menuText.trim();
//   if(jQuery('.menu-opening').length>0 && menuText == 'Our Products'){
//     e.preventDefault();
//     window.location="/collections/our-products";
//   }else if(jQuery('.menu_drawer__new').length>0 && menuText == 'Shop Supplements'){
//     e.preventDefault();
//     window.location="/collections/our-products";
//   }
// });

jQuery('.cart-summary__button').click(function(){
  $('.button-text').hide();
  $('.button-loader').show();
  setTimeout(function() {
    window.location.href="/checkout";
  }, 1000);
});

$(document).ready(function() {
    getHeaderHeight();
});
function getHeaderHeight(){
  var classHeaderHeight = jQuery('.menu-drawer').innerHeight();
  document.documentElement.style.setProperty('--vh', classHeaderHeight+'px');
}
$(window).on('resize', function () {
    getHeaderHeight();
})

// start: PRODUCT LIST NEW [sections/product-list.liquid]
$(document).ready(function () {
  jQuery(".pl_nav_list li").eq(0).addClass("current");
  jQuery(".tabs-content").find(".cl_maintab-content").eq(0).addClass("current");
  $("ul.pl_nav_list li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.pl_nav_list li").removeClass("current");
    $(".cl_maintab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $(".producttab-itemslick").slick("refresh");
  });
});
//COLLECTION TABING END
$(document).ready(function () {
var $swiperSelector = $('.swiper-container');
$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 4;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3;
    var slidesMobileinner = $this.data('slides-mobile-inner') ? $this.data('slides-mobile-inner') : 2;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;
    if(jQuery(window).width()<751){
      var lengthSize=Math.round(jQuery('.product-slidercount').val()/2);
      dragSize = (dragSize*lengthSize); 
    }else{
      dragSize = (dragSize*jQuery('.product-slidercount').val()); 
    }
  setTimeout(function(){
    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        991: {
          slidesPerView: slidesTablet
        },
        751: {
           slidesPerView: slidesMobile
        },
        300: {
           slidesPerView: slidesMobileinner
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
  },500);
});
});
// end: PRODUCT LIST NEW [sections/product-list.liquid]

jQuery(function(){
    createSticky(jQuery('#shopify-section-header'));
});
function createSticky(sticky) {

    if (typeof sticky !== "undefined") {

        var pos = sticky.offset().top,
                win = jQuery(window);

        win.on("scroll", function() {
            if(win.scrollTop()==pos){
                sticky.removeClass("fixed");                
            }else{
            win.scrollTop() >= pos ? sticky.addClass("fixed") : sticky.removeClass("fixed");      
            }
        });         
    }
}

jQuery('.variant__select').click(function(){
  var vtype = $(this).attr('data-type');
  $('.bundle_prog_step').removeClass('active');
  if(vtype == 'single tub'){
    var width = '25%';
    var progressMess = '<p>Add <b><span>1</span> more tub</b> to unlock <b>FREE</b> Shipping and Shaker</p>';
    $('.bundle_prog_step_1').addClass('active');
  }
  if(vtype == '2-pack'){
    var width = '75%';
    var progressMess = '<p>Add <b><span>1</span> more tub</b> to unlock Protein Samples</p>';
    $('.bundle_prog_step_1').addClass('active');
    $('.bundle_prog_step_2').addClass('active');
    $('.bundle_prog_step_3').addClass('active');
  }
  if(vtype == '3-pack'){
    var width = '100%';
    var progressMess = '<p><b>Congratulations, </b> you get all free gifts</p>';
    $('.bundle_prog_step_1').addClass('active');
    $('.bundle_prog_step_2').addClass('active');
    $('.bundle_prog_step_3').addClass('active');
    $('.bundle_prog_step_4').addClass('active');
  }
  $('.bundle_progress_fill').css('width', width);
  $('.bundle_progress_message').html(progressMess);
});


/* SEARCH BAR -- START */

setTimeout(function() {
    $('.search-modal__content').addClass('search-modal-new');
    $('.search-modal').addClass('main__search');
    $('.main__search #Search-In-Modal').attr('placeholder', 'Creatine, Protein, BCAA...');
}, 500);
var searchbutton = setInterval(function() {
    if($('.main__search .search-modal__form[results="true"]').length != 0){
        $('.main__search .search-modal__form[results="true"] .search_result__btn > span').text('VIEW ALL RESULTS');
        // clearInterval(searchbutton);
    }
}, 100);

/* SEARCH BAR -- END */

/* PAGINATION INFINITE LOADING -- START */

/*convert.$(document).ready(function(){ 
  let page = 2;
  let loading = false;
  let totalHeightminus = 1000;
  let totalPerPage = jQuery('#per_page_collection').val();
  let totalCollectionProduct=jQuery('#collection_total_products').val();
  let totalPage = Math.ceil(totalCollectionProduct/totalPerPage);
  let collectionUrl = jQuery('#collection_url').val();
  $(window).scroll(function() {
    var loadMoreThreshold = Math.round(jQuery('#product-grid').find('.Grid__Cell').last().offset().top); // Adjust this value based on your preference
    var finalHeight = (loadMoreThreshold);
    console.log("scroll height",$(window).scrollTop());
    console.log("final height",finalHeight);
    if (!loading && $(window).scrollTop() > finalHeight) {
      loadMore();
    }
  });
  function loadMore() {
    if (!loading) {
      loading = true;
      console.log("page",page);
      if(totalPage>=page){
        jQuery("#load-more-btn-wrapper").show();
        var url = window.location.origin + "/" + collectionUrl + "?page=" + page;
          //added for filter data for query string with filter start
          var queryString = window.location.search; // Includes the '?' at the start
          if(queryString!=""){
            var rawQueryString = queryString.substring(1);
            url = window.location.origin + "/" + collectionUrl + "?page=" + page+'&'+rawQueryString;
          }
        $.get(url, function(data) {
          //console.log("product",data);
          var newProducts = $(data).find('.ProductList--grid').html();
          if (newProducts.trim().length > 0) {
          $('#product-grid').append(newProducts);
          page++; // Increment page only if new products are loaded
          
          }else{
            loading = false;
              jQuery("#load-more-btn-wrapper").hide();  
          }
          
        }).fail(function() {
            loading = false; // Reset loading flag in case of failure
        });
      }else{
        loading=true;
        jQuery('#load-more-btn-wrapper').hide();
      }
    }
  }
});*/
function initializeLoadMorePagination() {
  console.log("load more calls");
  let page = 2;
  let loading = false;
  let totalHeightminus = 1000;

  let totalPerPage = parseInt(jQuery("#per_page_collection").val()) || 12;
  let totalCollectionProduct = parseInt(jQuery("#collection_total_products").val()) || $(".Grid__Cell").length;
  let collectionUrl = jQuery("#collection_url").val() || window.location.pathname.replace(/^\/+/, '');

  let totalPage = Math.ceil(totalCollectionProduct / totalPerPage);

  $(window).off("scroll.loadMore");

  if (totalCollectionProduct < totalPerPage) {
    jQuery("#load-more-btn-wrapper").hide();
    return;
  }

  $(window).on("scroll.loadMore", function () {
    const $lastProduct = $('#product-grid').find(".Grid__Cell").last();
    if ($lastProduct.length === 0) return;

    let loadMoreThreshold = Math.round($lastProduct.offset().top);
    let finalHeight = loadMoreThreshold - totalHeightminus;

    if (!loading && $(window).scrollTop() > finalHeight) {
      if (totalPage >= page) {
        loadMore();
      } else {
        loading = false;
        jQuery("#load-more-btn-wrapper").hide();
      }
    }
  });

  function loadMore() {
    if (!loading) {
      loading = true;
      let url = window.location.origin + "/" + collectionUrl + "?page=" + page;

      const queryString = window.location.search;
      if (queryString) {
        const rawQueryString = queryString.substring(1);
        url = window.location.origin + "/" + collectionUrl + "?page=" + page + '&' + rawQueryString;
      }

      $.get(url, function (data) {
        const newProducts = $(data).find(".ProductList--grid").html();
        if (newProducts && newProducts.trim().length > 0) {
          if(totalPage>=page){
            jQuery("#load-more-btn-wrapper").show();
          }else{
            jQuery("#load-more-btn-wrapper").hide();
          }
          $('.collection').find('#product-grid').append(newProducts);
        } else {
          jQuery("#load-more-btn-wrapper").hide();
        }
        loading = false;
        page++;
      }).fail(function () {
        loading = false;
        jQuery("#load-more-btn-wrapper").hide();
      });
    }
  }
}

jQuery(document).ready(function(){
  setTimeout(function(){
    jQuery("#load-more-btn-wrapper").hide();
  },7000);
  var pdcount = setInterval(function(){
    if(jQuery('.active-facets').find('.active-facets__button.active-facets__button--light').length>0){
      jQuery('.facets_apply_btn_count').show();
      var totalProducts = jQuery('#collection_total_products').val();
      jQuery('.facets_apply_btn_count').text('('+totalProducts+')');
    }else{
      jQuery('.facets_apply_btn_count').hide();
    }
    
  },500);
})

// Fallback for filter remove (in case event doesn't fire)
$(document).on("click", ".active-facets__button.active-facets__button--light", function () {
  setTimeout(() => {
    initializeLoadMorePagination();
  }, 500);
});

// Initialize the function when the document is ready
convert.$(document).ready(function () {
  initializeLoadMorePagination();
});

/*jQuery(document).on("click",".facets-container .active-facets__button-wrapper",function(){
  setTimeout(function(){
    initializeLoadMorePagination();
  },1000);
});
*/
jQuery(document).on("change",".mobile-facets__checkbox[type='checkbox']",function(){
  $('.collection').find('#product-grid').html('');
  setTimeout(function(){
    initializeLoadMorePagination();
    resetPriceSliderUI();
  },1000);
});

jQuery(document).on("change","#SortBy-mobile",function(){
  $('.collection').find('#product-grid').html('');
  setTimeout(function(){
    initializeLoadMorePagination();
  },1000);
});

jQuery(document).ready(function () {
  jQuery(document).on('click',"#SortByList li",function () {
    var selectedSort = jQuery(this).data("value");
    jQuery("#SortBy-mobile").val(selectedSort);
    
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("sort_by", selectedSort);
    window.history.pushState({}, '', currentUrl.href);
    //initializeLoadMorePagination();
    jQuery.ajax({
      url: currentUrl.pathname + currentUrl.search,
      type: "GET",
      dataType: "html",
      success: function (data) {
        var sortingData = jQuery(data).find("#ProductGridContainer").find("#product-grid").html();
        if(sortingData!=undefined){
          $('.collection').find('#product-grid').html('');
          $('.collection').find('#product-grid').append(sortingData);
        }
      },
      error: function (err) {
        console.log("Sort failed", err);
      }
    });
  });
});

/* PAGINATION INFINITE LOADING -- END */
jQuery(document).on('click','.add__btn_custom_button',function(e){
  var variantId='';
  variantId = jQuery(this).attr('data-vid');
  if(variantId != ''){
    $(this).hide();
    $(this).closest('.form').find('[name="id"]').val(variantId);
    $(this).closest('.form').find('.add__custom_loader').show();
    //$(this).closest('.form').find('[name="add"]').trigger('click');
    var itemArr = []
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
        window.location.href = '/cart';
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  e.preventDefault();
  return false;
});

jQuery(document).on('change','.add__btn_custom_sel',function(e){
  var variantId='';
  variantId = jQuery(this).val();
  if(variantId != ''){
    $(this).hide();
    $(this).closest('.form').find('.add__custom_loader').show();
    $(this).closest('.form').find('[name="id"]').val(variantId);
    //$(this).closest('.form').find('[name="add"]').trigger('click');
    jQuery(this).val('');
    var itemArr = []
    itemArr.push({
      id: variantId,
      quantity: 1
    });
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'POST',
      data: {items:itemArr},
      success: function(cart) {
        window.location.href = '/cart';
      },
      error: function(response) {
          alert('Something went wrong!!');
      }
    });
  }
  e.preventDefault();
  return false;
});


//PDP Details Page Radio Click Event
jQuery(document).on("change","[name='tab']",function(){
  jQuery('.main-teb').find('.tabing').removeClass("active");
  jQuery('.main-article').find('.article-section').hide();
  if(jQuery(this).is(":checked")){
    var radioVal = jQuery(this).val();
    ProductOfferSwitch(radioVal);
  }
});

jQuery(document).ready(function(){
  var radioVal = jQuery("[name='tab']:checked").val();
  ProductOfferSwitch(radioVal);
});

function ProductOfferSwitch(radioVal) {
  jQuery('.main-teb').find('.teb-'+radioVal).addClass("active");
  jQuery('.main-article').find(".article"+radioVal).show();
}

jQuery(document).on("change",".main-article .add__select_custom_cart",function(){
  variantPriceChange();
});
jQuery(document).on("change",".new-article .add__select_custom_cart",function(){
  variantPriceChange();
});

//Best Offer Secton Variant Wise Price Total And Price Change Start
function variantPriceChange(){
  var totalPrice = 0;
  var classBase = '.main-article';
  if(jQuery('.spacial-offer-vtwo_b').length!=0){
    classBase = '.new-article';
  }
  jQuery(classBase+' .add__select_custom_cart option:selected').each(function(){
    var priceMain = parseInt(jQuery(this).attr('data-price'));
    var comparePrice = parseInt(jQuery(this).attr('data-comprice'));
    if(priceMain!=undefined && priceMain>0){
      totalPrice+=priceMain;
      jQuery(this).parent().parent().parent('div').find('.article1-product-price').find('.price').text(Shopify.formatMoney(priceMain));
    }
    if(comparePrice!=undefined && comparePrice>0){
      jQuery(this).parent().parent().parent('div').find('.article1-product-price').find('.compare_at_price').text(Shopify.formatMoney(comparePrice));
    }
  });
  jQuery(classBase+' .article1-product-values').each(function(){
    if(jQuery(this).find('.add__select_custom_cart').length==0){
      var priceMain = parseInt(jQuery(this).siblings('.article1-product-price').find('.price').attr('data-price'));
      var comparePrice = parseInt(jQuery(this).siblings('.article1-product-price').find('.compare_at_price').attr('data-comprice'));
      if(priceMain!=undefined && priceMain>0){
        totalPrice+=priceMain;
      }
    }
  });
  
  if(totalPrice!=undefined){
    jQuery('.tabing.active').find('.tab_compare_price_vb .price').text(Shopify.formatMoney(totalPrice));
  }
}
//Best Offer Secton Variant Wise Price Total And Price Change End

/*********************** SUBSCRIPTION USPs JS -- START ***********************/
/*$(document).ready(function () {
  setTimeout(function(){
    if(jQuery('[name="purchaseOption"]').length>0){
      var valueOption = jQuery('[name="purchaseOption"]:checked').val();
      subscirbeHtml(valueOption);
    }
  },1000);
});

jQuery(document).on("change","[name='purchaseOption']",function(){
  var valueOption = jQuery(this).val();
  setTimeout(function(){
    subscirbeHtml(valueOption);
  },500);
});

jQuery(document).on("change","[name='rc_selling_plan']",function(){
  var valueOption = jQuery('[name="purchaseOption"]:checked').val();
  subscirbeHtml(valueOption);
});

function subscirbeHtml(val) {
  let getPrice = jQuery('.shopify-app-block.recharge-subscription-widget .onetime-radio');
  const intervalpriceId = setInterval(() => {
    const subscriptionTextR = getPrice.find('.rc-radio__label').text()?.trim();
    if (subscriptionTextR) {
      var matchedPrice = subscriptionTextR.match(/\$([\d.]+)/);
      console.log("matcheprice",matchedPrice);
      const widgetR = jQuery('.recharge-subscription-widget .onetime-radio');
      matchedPrice = matchedPrice[0];
      const updatedTextR = subscriptionTextR.replace(`${matchedPrice}`,'<span class="price-onetime rc-radio__price">'+matchedPrice+'</span>');
      widgetR.find('.rc-radio__label').html(updatedTextR);
      clearInterval(intervalpriceId);   
    }
  },1000);
  if(val === 'subscription') {
    jQuery('.rc-template__radio').find('.buy-once-details').remove();
    if(jQuery('.recharge-subscription-widget').length !== 0) {
      let days = jQuery('.rc-selling-plans-dropdown__select option:selected');
      const intervalId = setInterval(() => {
        const widget = jQuery('.recharge-subscription-widget');
        const subscriptionText = days.text()?.trim();
  
        if (subscriptionText) {
          var matchedPercentage = subscriptionText.match(/[\d]+/);
          jQuery('.subsave-usps').remove();
          days = matchedPercentage[0];
          clearInterval(intervalId);
          jQuery('.recharge-subscription-widget .rc-selling-plans-dropdown').append(`
          <ul class="subsave-usps">
            <li>Free delivery every <span class="percentage-save">${days}</span> days</li>
            <li>Guaranteed delivery during sell-outs</li>
            <li>Pause, update frequency, or cancel anytime</li>
          </ul>
        `);     
        }
      }, 500);
    }
  }
  if(val=='onetime'){
    const intervalId = setInterval(() => {
        clearInterval(intervalId);   
        jQuery('.subsave-usps').remove();
        jQuery('.recharge-subscription-widget .onetime-radio').after(`
          <div class="buy-once-details">
              <div class="buy-once-details-icon">
                <img src="https://cdn.shopify.com/s/files/1/0600/5643/6975/files/tabler_hand-click.png?v=1737702330">
              </div>
              <div class="buy-once-details-text">
                <div class="buy-once-details-heading">
                  <h4>Switch to a subscription and <b>save +$10.</b></h4>
                </div>
                <div class="buy-once-details-content">
                  <span>Pause, update frequency or cancel anytime.</span>
                </div>
              </div>
            </div>`);
    
    }, 500);
  }
}*/
/*********************** SUBSCRIPTION USPs JS -- END *************************/

document.addEventListener("DOMContentLoaded", function () {
    let displayElement = document.getElementById("timer-display");

    function setNewEndTime() {
        let newEndTime = Math.floor(Date.now() / 1000) + 18000; // 5 hours from now
        localStorage.setItem("countdownEndTime", newEndTime); // Save in localStorage
        return newEndTime;
    }

    let endTime = parseInt(localStorage.getItem("countdownEndTime")) || setNewEndTime();

    function updateCountdown() {
        let now = Math.floor(Date.now() / 1000);
        let timeLeft = endTime - now;

        if (timeLeft > 0) {
            let hours = Math.floor(timeLeft / 3600);
            let minutes = Math.floor((timeLeft % 3600) / 60);
            displayElement.textContent = `${hours} hours and ${minutes} minutes`;
        } else {
            endTime = setNewEndTime(); // Reset timer when it reaches zero
        }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
});
const priceGap = 10;
const $rangeInput = $(".range-input input");
const $priceInput = $(".price-input input");
let $range = $(".slider .progress");

//FILTER CHECKBOX CHECKED FOR ADDED CLASS FILTER FOOTER JS STARTc
jQuery(document).ready(function(){
  setTimeout(function(){
    addClassFilter();
  },1000);
});
jQuery(document).on('change','#FacetFiltersFormMobile .mobile-facets__checkbox',function(){
  addClassFilter();
  let minVal = parseInt($rangeInput.eq(0).val());
  let maxVal = parseInt($rangeInput.eq(1).val());
  //filterExludePrice(jQuery(this));
});
jQuery(document).on('click','#FacetFiltersFormMobile .mobile-facets__clear-wrapper',function(){
  jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').removeClass('facet-filter-active');
});
function addClassFilter(){
  if(jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').length>0){
    if(jQuery('#FacetFiltersFormMobile').find('.mobile-facets__checkbox:checked').length>0){
      jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').addClass('facet-filter-active');
    }else{
      jQuery('#FacetFiltersFormMobile').find('.facets__footer_main').removeClass('facet-filter-active');
    }
  }
}
//FILTER CHECKBOX CHECKED FOR ADDED CLASS FILTER FOOTER JS END

//FILTER PRICE RANGE PICKER JS START


// Initialize progress bar
let defaultMin=0;
let defaultMax=0;
function initializeProgress() {
  let minVal = parseInt($rangeInput.eq(0).val());
  let maxVal = parseInt($rangeInput.eq(1).val());

  if($(".slider .progress").length>0){
    $(".slider .progress").css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
    $(".slider .progress").css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
  }
  setTimeout(function(){
    if(jQuery('.main_collection_container').hasClass('filter-versions')){
      $("#Mobile-Filter-Price-GTE").val(minVal);
      $("#Mobile-Filter-Price-LTE").val(maxVal);
      defaultMin = minVal;
      defaultMax = maxVal;
    }
  },1000);

  //$priceInput.eq(0).val(minVal);
  //$priceInput.eq(1).val(maxVal);
}
function resetPriceSliderUI() {
  setTimeout(function () {
    var $rangeInput = $(".range-input input");
    var $priceInput = $(".price-input input");
    var $range = $(".slider .progress");

    let minVal = parseInt($rangeInput.eq(0).attr("min"), 10) || 0;
    let maxVal = parseInt($rangeInput.eq(1).attr("max"), 10) || 1000;

    // Update progress bar after inputs are set
    setTimeout(function () {
      if ($range.length > 0) {
        let newMin = parseInt($rangeInput.eq(0).val(), 10);
        let newMax = parseInt($rangeInput.eq(1).val(), 10);

        $range.css("left", (newMin / $rangeInput.eq(0).attr("max")) * 100 + "%");
        $range.css("right", 100 - (newMax / $rangeInput.eq(1).attr("max")) * 100 + "%");
      }
    }, 200);
  }, 200);
}

$(document).on("click", ".active-facets__button-remove", function () {
  setTimeout(function () {
    var $rangeInput = $(".range-input input");
    var $priceInput = $(".price-input input");
    var $range = $(".slider .progress");

    let minVal = parseInt($rangeInput.eq(0).attr("min"), 10) || 0;
    let maxVal = parseInt($rangeInput.eq(1).attr("max"), 10) || 1000;

    setTimeout(function(){
      if ($(".slider .progress").length > 0) {
        let minVal = parseInt($rangeInput.eq(0).val(), 10);
        let maxVal = parseInt($rangeInput.eq(1).val(), 10);
      
        $(".slider .progress").css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
        $(".slider .progress").css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
      }
    },500);
    initializeLoadMorePagination();
  }, 300); // use 500ms, adjust if needed based on Shopify's update speed
  
});
// Call initialize on page load
$(document).ready(function () {
  initializeProgress();
});

function filterExludePrice(htmlform){
  if(jQuery('.main_collection_container').hasClass('filter-versions')){
    var getminPrice = parseInt($priceInput.eq(0).val(), 10);
    var getmaxPrice = parseInt($priceInput.eq(1).val(), 10);
    if(defaultMin == getminPrice || defaultMax == getmaxPrice){
      const $form = htmlform.closest('form');
      const formData = $form.serializeArray();
      console.log("formData",formData);
      // Remove price-related params
      const excludeKeys = [
        'filter.v.price',
        'filter.v.price.gte',
        'filter.v.price.lte'
      ];
    
      // Filter out unwanted params
      const filteredParams = formData.filter(param => {
        return !excludeKeys.some(key => param.name.includes(key));
      });
    
      // Build the clean query string
      const queryString = $.param(filteredParams);
      const url = `${window.location.pathname}?${queryString}`;

      console.log("urlll",url);
      // Update the browser URL without reloading
      setTimeout(function(){
        history.replaceState(null, '', url);
      },800);
    }
  }
}

$(document).on('input', '.price-input input', function () {
  const $rangeInput = $(".range-input input");
  const $priceInput = $(".price-input input");
  const $range = $(".slider .progress");
  
  let minPrice = parseInt($priceInput.eq(0).val(), 10);
  let maxPrice = parseInt($priceInput.eq(1).val(), 10);

  if (maxPrice - minPrice >= priceGap && maxPrice <= parseInt($rangeInput.eq(1).attr("max"), 10)) {
    if ($(this).hasClass("input-min")) {
      $rangeInput.eq(0).val(minPrice);
      $("#Mobile-Filter-Price-GTE").val(minPrice);
      $range.css("left", (minPrice / $rangeInput.eq(0).attr("max")) * 100 + "%");
    } else {
      $rangeInput.eq(1).val(maxPrice);
      $("#Mobile-Filter-Price-LTE").val(maxPrice);
      $range.css("right", 100 - (maxPrice / $rangeInput.eq(1).attr("max")) * 100 + "%");
    }
  }
});

$(document).on('input', '.range-input input', function () {
  const $rangeInput = $(".range-input input");
  const $priceInput = $(".price-input input");
  const $range = $(".slider .progress");

  let minVal = parseInt($rangeInput.eq(0).val(), 10);
  let maxVal = parseInt($rangeInput.eq(1).val(), 10);

  if (maxVal - minVal < priceGap) {
    if ($(this).hasClass("range-min")) {
      $rangeInput.eq(0).val(maxVal - priceGap).trigger("input");
    } else {
      $rangeInput.eq(1).val(minVal + priceGap).trigger("input");
    }
  } else {
    $priceInput.eq(0).val(minVal);
    $priceInput.eq(1).val(maxVal);
    $range.css("left", (minVal / $rangeInput.eq(0).attr("max")) * 100 + "%");
    $range.css("right", 100 - (maxVal / $rangeInput.eq(1).attr("max")) * 100 + "%");
  }
});
//FILTER PRICE RANGE PICKER JS END

/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS START ************************/
//collection page visit to set previous and next link
$(document).ready(function () {
    if($('.page-collection').find('#ProductGridContainer').length > 0) {
      localStorage.setItem("prevProduct", '');
      localStorage.setItem("nextProduct", '');
      localStorage.setItem("collectionName", '');
      localStorage.setItem("currentProduct", '');

      let productLinks = $('#ProductGridContainer').find(".card-information__wrapper a.full-unstyled-link");
      let productArray = [];
      
      // Store all product URLs in an array
      productLinks.each(function () {
          productArray.push($(this).attr("href"));
      });
      //console.log("productArray",productArray);
      // Save product URLs in localStorage
      localStorage.setItem("productList", JSON.stringify(productArray));
      let prevProduct = window.location.href;
      localStorage.setItem("prevProduct", prevProduct);
      let collectionName = '';
      if (jQuery('.collection-hero').find('.collection-hero__title').length > 0) {
          collectionName = jQuery('.collection-hero').find('.collection-hero__title').text();
      }
      //console.log("collectionName",collectionName);
      localStorage.setItem("collectionName", collectionName);
        // Detect product click and save previous & next product links
      jQuery(document).on('click', '#ProductGridContainer .card-wrapper a', function () {
          let clickedProduct = $(this).attr("href");
          //console.log("clickedProduct",clickedProduct);
          let storedProducts = JSON.parse(localStorage.getItem("productList")) || [];
          let productIndex = storedProducts.indexOf(clickedProduct);
          let nextProduct = productIndex < storedProducts.length - 1 ? storedProducts[productIndex + 1] : null;
          localStorage.setItem("nextProduct", nextProduct);
          
      });
    } else if (jQuery('body').hasClass('template-index')) {
        localStorage.setItem("prevProduct", '');
        localStorage.setItem("nextProduct", '');
        localStorage.setItem("collectionName", '');
        localStorage.setItem("currentProduct", '');
    }
});

// Product details page: Get previous and next links
$(document).ready(function () {
  //console.log("checkkkk",window.getComputedStyle(document.querySelector('.breadcrumb-wrapper')).display);
  if(jQuery('.breadcrumb-wrapper').is(':visible')) {
      let productArray = JSON.parse(localStorage.getItem("productList")) || [];
      let currentProduct = localStorage.getItem("currentProduct");
      let prevProduct = localStorage.getItem("prevProduct");
    
      let nextProduct = localStorage.getItem("nextProduct");
      let collectName = localStorage.getItem("collectionName");
      //console.log("prevProduct",prevProduct,collectName);
      let productIndex = productArray.indexOf(currentProduct);
      let newNextProduct = productIndex < productArray.length - 1 ? productArray[productIndex + 1] : null;

      let objlinkhtml = jQuery('.breadcrumb-wrapper').find('.breadcrumbs-one');
      let objlinkhtml1 = jQuery('.breadcrumb-wrapper').find('.breadcrumbs-two');
      let flagnav = 0;
      if(collectName!="" && collectName!=undefined){
        collectName=collectName.replace('Collection:','');
      }
      // Set Previous Product Link
      if(jQuery('.breadcrumb-wrapper').find('.breadcrumbs-three').is(':visible')){
       if(prevProduct){
         var targetHref = prevProduct.replace(/^.*\/\/[^\/]+/, '');
         var cleanUrl = targetHref.split('?')[0];
         jQuery('.breadcrumb-wrapper .collection-list-wrapper li.collection-name').each(function () {
            var $li = jQuery(this);
            var $anchor = $li.find('a');
            var anchorHref = $anchor.attr('href')?.split('?')[0]; // remove query string
            //console.log("anchorHref",anchorHref,cleanUrl);
            if (anchorHref === cleanUrl) {
              console.log("Match found for:", anchorHref);
              jQuery('.breadcrumb-wrapper .collection-list-wrapper li').removeClass('active');
              $li.addClass('active');
        
              // Move matched <li> to very top of the list (before .collection-title)
              $li.prependTo('.collection-list-wrapper');
        
              return false;
            }
         });
       }
      }else if (prevProduct) {
          if (collectName !== "") {
            
            objlinkhtml.find(".prev-product .collection-title").text(collectName);
            objlinkhtml1.find(".prev-product .collection-title").text(collectName);
          } else {
              let cleanUrl = prevProduct.split('?')[0];
              let lastSegment = cleanUrl.split('/').filter(Boolean).pop();

              if (lastSegment) {
                  let upperCaseName = decodeURIComponent(lastSegment).replace(/-/g, ' ').toUpperCase();
                  objlinkhtml.find(".prev-product .collection-title").text(upperCaseName);
                objlinkhtml1.find(".prev-product .collection-title").text(upperCaseName);
              }
          }
          objlinkhtml.find(".prev-product").attr("href", prevProduct);
          objlinkhtml1.find(".prev-product").attr("href", prevProduct);
      } else {
          //objlinkhtml.find(".prev-product").hide();
          flagnav = 1;
      }

      // Set Next Product Link
      if(nextProduct) {
        objlinkhtml.find(".next-product").attr("href", nextProduct);
        objlinkhtml1.find(".next-product").attr("href", nextProduct);
      }else{
        //objlinkhtml.find(".next-product").hide();
        flagnav = 1;
      }

      if (flagnav === 0) {
          jQuery('.page-product').find('.nextprev-wrap').addClass('active-wrap');
      }

      // Update current product and next product on click
      jQuery(document).on("click", ".next-product", function () {
          localStorage.setItem("currentProduct", nextProduct);
          let nextIndex = productArray.indexOf(nextProduct);
          let newNextProduct = nextIndex < productArray.length - 1 ? productArray[nextIndex + 1] : null;
          localStorage.setItem("nextProduct", newNextProduct);
      });
  }
});
/********************** COLLECTION PAGE VISIT AND AFTER CLICK PRODUCT TO SET PREVIOUS AND NEXT PRODUCT LINK DETAILS PAGE JS END ************************/